import React, { useEffect } from 'react';
import { Box, Tabs, Tab, Tooltip } from '@mui/material';

// Tab navigation shared by the admin sections that have sub-pages
// (Registration, Workshops, Awards). tabs: [{ id, label, description }] —
// description becomes the tab's hover text. activeSection/setActiveSection
// is AdminDashboard's shared sub-page state (regSection), so breadcrumbs,
// pinned pages and sidebar search keep pointing at a specific tab.
//
// Opening a section (or arriving with an id this section doesn't have)
// goes to the tab last used in it, else the first. With only one tab the
// bar is hidden and that page shows on its own.
const LAST_TAB_KEY = 'admin:lastTab';

function readLastTabs() {
  try { return JSON.parse(localStorage.getItem(LAST_TAB_KEY)) || {}; } catch { return {}; }
}

export default function SectionTabs({ sectionKey, tabs, activeSection, setActiveSection, children }) {
  const current = tabs.find(t => t.id === activeSection);

  useEffect(() => {
    if (current) {
      try { localStorage.setItem(LAST_TAB_KEY, JSON.stringify({ ...readLastTabs(), [sectionKey]: current.id })); } catch { /* not essential */ }
      return;
    }
    if (!tabs.length) return;
    const last = readLastTabs()[sectionKey];
    setActiveSection(tabs.some(t => t.id === last) ? last : tabs[0].id);
  }, [current, sectionKey, tabs, setActiveSection]);

  if (!current) return null; // redirecting to a tab (above)

  return (
    <>
      {tabs.length > 1 && (
        <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2.5 }}>
          <Tabs value={current.id} onChange={(e, id) => setActiveSection(id)} variant="scrollable" scrollButtons="auto" allowScrollButtonsMobile>
            {tabs.map(t => (
              <Tab key={t.id} value={t.id} sx={{ textTransform: 'none', fontWeight: 500 }}
                label={t.description ? <Tooltip title={t.description} enterDelay={600}><span>{t.label}</span></Tooltip> : t.label} />
            ))}
          </Tabs>
        </Box>
      )}
      {children(current.id)}
    </>
  );
}
